<p-toast></p-toast>
<div class="container-fluid container-fullw">
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            <span *ngIf="comment.id === null">{{ 'NEWCOMMENT' | translate }}</span>
            <span *ngIf="comment.id !== null">{{ 'EDITCOMMENT' | translate }}</span>
          </ng-template>
          <form pFocusTrap name="commentForm" id="commentForm" novalidate (ngSubmit)="submitForm(true)" [formGroup]="commentForm" >
            <input type="hidden" name="id" id="commentId" formControlName="id" />
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-table "></i>
                    </span>
                    <span class="p-float-label">
                      <input id="commentEntity" formControlName="entity" type="text" pInputText [required]="true"> 
                      <label for="commentEntity" class="req">{{ 'ENTITY' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="commentForm.controls['entity'].invalid && (commentForm.controls['entity'].dirty || commentForm.controls['entity'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="commentForm.controls['entity'].errors !== null">
                  <div *ngIf="commentForm.controls['entity'].errors.required">
                   {{ 'ENTITYREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-project-diagram "></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="commentForeignKey" formControlName="foreignKey" [step]="1" [showButtons]="true" [required]="true"></p-inputNumber>
                      <label for="commentForeignKey" class="req">{{ 'FOREIGNKEY' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="commentForm.controls['foreignKey'].invalid && (commentForm.controls['foreignKey'].dirty || commentForm.controls['foreignKey'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="commentForm.controls['foreignKey'].errors !== null">
                  <div *ngIf="commentForm.controls['foreignKey'].errors.required">
                   {{ 'FOREIGNKEYREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="commentPseudo" formControlName="pseudo" type="text" pInputText [required]="true"> 
                      <label for="commentPseudo" class="req">{{ 'PSEUDO' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="commentForm.controls['pseudo'].invalid && (commentForm.controls['pseudo'].dirty || commentForm.controls['pseudo'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="commentForm.controls['pseudo'].errors !== null">
                  <div *ngIf="commentForm.controls['pseudo'].errors.required">
                   {{ 'PSEUDOREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="commentAge" formControlName="age" [step]="1" [showButtons]="true" [required]="true"></p-inputNumber>
                      <label for="commentAge" class="req">{{ 'AGE' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="commentForm.controls['age'].invalid && (commentForm.controls['age'].dirty || commentForm.controls['age'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="commentForm.controls['age'].errors !== null">
                  <div *ngIf="commentForm.controls['age'].errors.required">
                   {{ 'AGEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-direction"></i>
                    </span>
                    <span class="p-float-label">
                      <p-dropdown  inputId="commentCityId" [autoDisplayFirst]="false" formControlName="city" [options]="commentsColumnsService.cities" optionValue="id" optionLabel="name" [required]="false" [filter]="true"></p-dropdown>
                      <label for="commentCityId" class="">{{ 'CITY' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-icons "></i>
                    </span>
                    <span class="p-float-label">
                      <input id="commentIcon" formControlName="icon" type="text" pInputText [required]="true"> 
                      <label for="commentIcon" class="req">{{ 'ICON' | translate }}</label>
                    </span>
                    <button type="button" pButton pRipple icon="pi pi-folder" styleClass="p-button-info" (click)="openFilerDialog('icon')"></button> 
                  </div>
                </div>
                <div *ngIf="commentForm.controls['icon'].invalid && (commentForm.controls['icon'].dirty || commentForm.controls['icon'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="commentForm.controls['icon'].errors !== null">
                  <div *ngIf="commentForm.controls['icon'].errors.required">
                   {{ 'ICONREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="far fa-file-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="commentSubject" formControlName="subject" type="text" pInputText [required]="true"> 
                      <label for="commentSubject" class="req">{{ 'SUBJECT' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="commentForm.controls['subject'].invalid && (commentForm.controls['subject'].dirty || commentForm.controls['subject'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="commentForm.controls['subject'].errors !== null">
                  <div *ngIf="commentForm.controls['subject'].errors.required">
                   {{ 'SUBJECTREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-calculator"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="commentBody" formControlName="body" type="text" pInputText [required]="true"> 
                      <label for="commentBody" class="req">{{ 'BODY' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="commentForm.controls['body'].invalid && (commentForm.controls['body'].dirty || commentForm.controls['body'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="commentForm.controls['body'].errors !== null">
                  <div *ngIf="commentForm.controls['body'].errors.required">
                   {{ 'BODYREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12" [hidden]="common.currentUser.roles.join('').indexOf('ROLE_ADMIN_PUBLISHER') === -1" >
                  <label for="commentStatus" class="req">{{ 'STATUS' | translate }}</label>
                  <div class="p-formgroup-inline">
                    <div class="p-field-checkbox" *ngFor="let option of commentsColumnsService.statusesOptions; let i = index">
                      <p-radioButton inputId="commentStatus_{{ i }}" formControlName="status" name="status" [value]="option.value"></p-radioButton>
                      <label for="commentStatus_{{ i }}">{{ option.label | translate }}</label>
                    </div>
                  </div>
                </div>
                <div *ngIf="commentForm.controls['status'].invalid && (commentForm.controls['status'].dirty || commentForm.controls['status'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="commentForm.controls['status'].errors !== null">
                  <div *ngIf="commentForm.controls['status'].errors.required">
                   {{ 'STATUSREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->

            <div class="p-fluid p-grid">
              <div class="p-col-4">
                <button (click)="list()" class="btn btn-primary pull-left">
                  <i class="icon-layout-list-thumb"></i>
                  <span class="p-ml-1">{{ 'BACKCOMMENTS' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4 text-center">
                <button *ngIf="comment.id !== null" type="button" (click)="submitForm(false)" class="btn btn-primary" [disabled]="!commentForm.valid || disableSubmit"> <!--  [disabled]="commentForm.$invalid" -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && !redirect"></i>
                  <i class="fas fa-check-circle" *ngIf="!(disableSubmit && !redirect)"></i>
                  <span class="p-ml-1"> {{ 'APPLY' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4">
                <button type="button" (click)="submitForm(true)" class="btn btn-primary pull-right" [disabled]="disableSubmit"> <!--  [disabled]="!commentForm.valid || " -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && redirect"></i>
                  <i class="icon-save" *ngIf="!(disableSubmit && redirect)"></i>
                  <span class="p-ml-1">{{ 'SAVE' | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </p-fieldset>
        <div class="p-fluid p-grid">
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
          <div class="col-sm-12 p-col-4 mb-2 text-center">
          </div>
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
        </div>
      </div>
    </div><!--/p-col-12-->
  </div><!--/p-fluid p-grid-->
  <p-scrollTop target="parent"></p-scrollTop>
</div><!--/container-fluid container-fullw-->
<!-- end: FORM -->

